import React, {Component} from 'react'
import TemplateEditForm from "./form/edit.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'

class TemplateEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            form: '',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        AppContext.getApiClient().get('/documents/' + this.props.match.params.documentId).then(res => {
            this.setState({
                form: <TemplateEditForm value={res} />
            })
        });
    }

    render() {
        return (
            <div>
                {this.state.form}
            </div>
        );
    }
}

export default TemplateEdit


// WEBPACK FOOTER //
// ./src/template/edit.component.jsx